import { render, staticRenderFns } from "./Erro.vue?vue&type=template&id=ffc3719e&"
import script from "./Erro.vue?vue&type=script&lang=js&"
export * from "./Erro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports